<script lang="ts">
  /**
   * BottomNav — mobile navigation (DESIGN-SYSTEM §8.8). <768px only.
   * 5 items max: Queue, All, Import, Duplicates, Tags.
   */
  import { _ } from 'svelte-i18n'
  import { page } from '$app/state'
  import { Inbox, BookOpen, Upload, Copy, Tags } from 'lucide-svelte'

  const NAV_ITEMS = [
    { href: '/', labelKey: 'nav.queue', icon: Inbox },
    { href: '/bookmarks', labelKey: 'nav.all', icon: BookOpen },
    { href: '/import', labelKey: 'nav.import', icon: Upload },
    { href: '/duplicates', labelKey: 'nav.duplicates', icon: Copy },
    { href: '/tags', labelKey: 'nav.tags', icon: Tags },
  ] as const

  function isActive(href: string): boolean {
    if (href === '/') return page.url.pathname === '/'
    return page.url.pathname.startsWith(href)
  }
</script>

<nav class="bottom-nav">
  {#each NAV_ITEMS as item (item.href)}
    <a href={item.href} class="nav-item" class:active={isActive(item.href)}>
      <item.icon size={20} />
      <span class="nav-label">{$_(item.labelKey)}</span>
    </a>
  {/each}
</nav>

<style>
  .bottom-nav {
    display: none;
  }

  @media (max-width: 767px) {
    .bottom-nav {
      display: flex;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 100;
      height: calc(var(--bottom-nav-height) + env(safe-area-inset-bottom));
      padding-bottom: env(safe-area-inset-bottom);
      background: var(--color-bg-primary);
      border-top: 1px solid var(--color-border);
    }

    .nav-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      color: var(--color-text-tertiary);
      text-decoration: none;
    }

    .nav-item:hover {
      text-decoration: none;
    }

    .nav-item.active {
      color: var(--color-accent);
    }

    .nav-label {
      font-size: 10px;
      font-weight: 500;
    }
  }
</style>
